import React, { useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Plus, Upload, Loader2 } from 'lucide-react';
import { Input } from './ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = 'h-9 bg-black border-[#1F242C] text-white';
const sel = 'h-9 bg-black border border-[#1F242C] text-white text-sm px-2 rounded-sm';
const addBtn = 'h-8 px-3 text-xs flex items-center gap-1 border border-[#1F242C] text-[#BFBFBF] hover:text-white rounded-sm';

export function NotesEditor({ notes, onChange, idx }) {
  const set = (i, p) => onChange(notes.map((n, j) => (j === i ? { ...n, ...p } : n)));
  return (
    <div className="space-y-2" data-testid={`admin-guide-notes-${idx}`}>
      <p className="text-[11px] uppercase tracking-wider text-[#7A7F87]">Note e avvisi</p>
      {notes.map((n, i) => (
        <div key={i} className="flex gap-2">
          <select value={n.kind} onChange={(e) => set(i, { kind: e.target.value })} className={sel} data-testid={`admin-guide-note-kind-${idx}-${i}`}>
            <option value="nota">Nota</option><option value="attenzione">Attenzione</option>
          </select>
          <Input value={n.text} onChange={(e) => set(i, { text: e.target.value })} placeholder="Testo della nota" className={`${field} flex-1`} data-testid={`admin-guide-note-text-${idx}-${i}`} />
          <button onClick={() => onChange(notes.filter((_, j) => j !== i))} className="h-9 w-9 flex items-center justify-center border border-[#1F242C] text-[#8A8F97] hover:text-[#E37A72]" data-testid={`admin-guide-note-del-${idx}-${i}`}><Trash2 size={14} /></button>
        </div>
      ))}
      <button onClick={() => onChange([...notes, { kind: 'nota', text: '' }])} className={addBtn} data-testid={`admin-guide-note-add-${idx}`}><Plus size={12} />Nota</button>
    </div>
  );
}

export function MediaEditor({ media, onChange, idx, headers }) {
  const file = useRef(null);
  const [busy, setBusy] = React.useState(false);
  const set = (i, p) => onChange(media.map((m, j) => (j === i ? { ...m, ...p } : m)));
  const upload = async (e) => {
    const f = e.target.files?.[0]; e.target.value = '';
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append('file', f);
      const { data } = await axios.post(`${API}/admin/portal/guide/media`, fd, { headers });
      onChange([...media, { kind: 'image', url: data.url, caption: '' }]);
    } catch (err) { toast.error(err?.response?.data?.detail || 'Caricamento non riuscito'); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid={`admin-guide-media-${idx}`}>
      <p className="text-[11px] uppercase tracking-wider text-[#7A7F87]">Immagini, animazioni e link</p>
      {media.map((m, i) => (
        <div key={i} className="flex flex-wrap gap-2 items-center">
          {m.kind === 'image' && <img src={m.url.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${m.url}` : m.url} alt="" className="h-9 w-14 object-cover border border-[#1F242C]" />}
          <select value={m.kind} onChange={(e) => set(i, { kind: e.target.value })} className={sel} data-testid={`admin-guide-media-kind-${idx}-${i}`}>
            <option value="image">Immagine</option><option value="link">Link</option>
          </select>
          <Input value={m.url} onChange={(e) => set(i, { url: e.target.value })} placeholder="Indirizzo" className={`${field} flex-1 min-w-[180px] font-mono text-xs`} data-testid={`admin-guide-media-url-${idx}-${i}`} />
          <Input value={m.caption} onChange={(e) => set(i, { caption: e.target.value })} placeholder="Didascalia" className={`${field} flex-1 min-w-[160px]`} data-testid={`admin-guide-media-caption-${idx}-${i}`} />
          <button onClick={() => onChange(media.filter((_, j) => j !== i))} className="h-9 w-9 flex items-center justify-center border border-[#1F242C] text-[#8A8F97] hover:text-[#E37A72]" data-testid={`admin-guide-media-del-${idx}-${i}`}><Trash2 size={14} /></button>
        </div>
      ))}
      <div className="flex gap-2">
        <input ref={file} type="file" accept="image/png,image/jpeg,image/gif,image/webp" className="hidden" onChange={upload} data-testid={`admin-guide-media-file-${idx}`} />
        <button onClick={() => file.current?.click()} disabled={busy} className={addBtn} data-testid={`admin-guide-media-upload-${idx}`}>{busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />}Carica immagine</button>
        <button onClick={() => onChange([...media, { kind: 'link', url: '', caption: '' }])} className={addBtn} data-testid={`admin-guide-media-link-${idx}`}><Plus size={12} />Link</button>
      </div>
    </div>
  );
}
